import { useEffect, useRef, useState } from "react";
import { Bars, Circles } from "react-loader-spinner";
import nodata from "../../Assets/Image/admin/nodata.png";
import add from "../../Assets/Image/admin/add.png";
import { useNavigate } from "react-router-dom";
import Dialog from "../../Base-Component/Dialog/Dialog";
import edit from "../../Assets/Image/admin/edit.png";
import {
  addUserRole,
  deleteUserRole,
  getUserRole,
  updateUserRole,
} from "../../Services/ApiServices";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import deletes from "../../Assets/Image/admin/delete.png";

function UserRole() {
  const navigate = useNavigate();
  const scrollRef = useRef(null);

  const [isDragging, setIsDragging] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isModalOpens, setModalOpens] = useState(false);
  const [isAddUserRole, setIsAddUserRole] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  const [pageNo, setPageNo] = useState(1);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const [totalPage, setTotalPage] = useState("");
  const [roleName, setRoleName] = useState("");
  const [roleId, setRoleId] = useState("");
  const [isIndex, setIsIndex] = useState("");

  const [userData, setUserData] = useState([]);

  const handleUserList = () => {
    setLoader(true);
    let obj = {
      page: pageNo,
    };
    getUserRole(obj)
      .then((res) => {
        const data = res.data.data;
        setUserData(data);
        setTotalPage(res.data.totalPages);
        setLoader(false);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err.response.data.message);
        }
        setLoader(false);
      });
  };

  useEffect(() => {
    handleUserList();
  }, [pageNo]);

  const startDragging = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
    document.body.style.userSelect = "none";
  };

  const stopDragging = () => {
    setIsDragging(false);
    document.body.style.userSelect = "";
  };

  const onDragging = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  const renderPaginationButtonss = () => {
    const maxPagesToShow = 3;
    const buttons = [];
    const startPage = Math.max(1, pageNo - Math.floor(maxPagesToShow / 2));
    const endPage = Math.min(totalPage, startPage + maxPagesToShow - 1);

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={
            i === pageNo
              ? "px-4 py-[7px] mx-1 bg-[#EA5F5F1A] rounded-md text-[#EA5F5F]"
              : "px-4 py-[7px] mx-1 text-[#EA5F5F]"
          }
        >
          {i}
        </button>
      );
    }
    return buttons;
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPage) {
      setPageNo(page);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (isUpdate) {
      let obj = {
        role_name: roleName,
        role_id: roleId,
      };
      updateUserRole(obj)
        .then((res) => {
          toast.success(res.data.message);
          setIsAddUserRole(false);
          handleUserList();
        })
        .catch((err) => {
          if (err.response.status == 401) {
            Cookies.remove("e_learning_token");
            navigate("/login");
          } else {
            toast.error(err.response.data.message);
          }
          setIsLoading(false);
        });
    } else {
      let obj = {
        role_name: roleName,
      };
      addUserRole(obj)
        .then((res) => {
          toast.success(res.data.message);
          setIsAddUserRole(false);
          handleUserList();
        })
        .catch((err) => {
          if (err.response.status == 401) {
            Cookies.remove("e_learning_token");
            navigate("/login");
          } else {
            toast.error(err.response.data.message);
          }
          setIsLoading(false);
        });
    }
  };

  const handleEdit = (data) => {
    setIsAddUserRole(true);
    setRoleName(data.role_name);
    setIsUpdate(true);
    setRoleId(data.id);
    setIsLoading(false);
  };

  const handleDeleteView = (id, index) => {
    setIsDelete(true);
    setRoleId(id);
    setIsIndex(index);
    setIsLoading(false);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    setIsLoading(true);

    let obj = {
      id: roleId,
    };
    deleteUserRole(obj)
      .then((res) => {
        toast.success(res.data.message);
        setIsDelete(false);
        const data = [...userData];
        data.splice(isIndex, 1);
        setUserData(data);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err.response.data.message);
        }
        setIsLoading(false);
      });
  };

  return (
    <div className="md:m-4 m-1 fontNew">
      <div className="flex sm:flex-nowrap flex-wrap justify-end mb-7">
        <div className="flex sm:flex-nowrap flex-wrap-reverse items-center justify-end sm:w-auto w-full">
          <div>
            <button
              onClick={() => {
                setIsAddUserRole(true);
                setRoleName("");
                setIsUpdate(false);
              }}
              className="bg-[#e29c29] text-white flex items-center py-2 px-3 sm:mb-0 mb-3 rounded-lg whitespace-nowrap"
            >
              <img src={add} className="w-6 mr-2" alt="" />
              Add User Role
            </button>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-12">
        {loader ? (
          <div className="flex justify-center items-center col-span-12 h-[70vh]">
            <Bars
              height="35"
              width="35"
              color="#e29c29"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
          </div>
        ) : (
          <>
            {userData.length === 0 ? (
              <div className="col-span-12 h-[50vh] justify-center flex items-center">
                <img src={nodata} className="w-28" alt="No data" />
              </div>
            ) : (
              <>
                <div className="col-span-12">
                  <div
                    className="w-full lg:overflow-hidden overflow-auto"
                    onMouseDown={startDragging}
                    onMouseLeave={stopDragging}
                    onMouseUp={stopDragging}
                    onMouseMove={onDragging}
                    ref={scrollRef}
                  >
                    <table className="w-full border-separate border-spacing-y-3">
                      <thead>
                        <tr className="bg-white">
                          <th className="py-4 px-7 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                            <h4>ROLE ID</h4>
                          </th>
                          <th className="py-4 px-2 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                            <h4>ROLE NAME</h4>
                          </th>
                          <th className="py-4 px-2 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                            <div className="text-center">
                              <h4>ACTION</h4>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {userData.map((item, index) => (
                          <tr key={index} className="font-medium bg-white">
                            <td className="text-start px-7 py-3 first:rounded-l-lg last:rounded-r-lg">
                              <div className="whitespace-nowrap">{item.id}</div>
                            </td>
                            <td className="text-start lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg">
                              <div className="whitespace-nowrap">
                                <p className="text-base truncate w-[250px]">
                                  {item.role_name || ""}
                                </p>
                              </div>
                            </td>
                            <td className="text-start flex justify-center lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg">
                              <div className="flex items-center w-52 justify-center">
                                <div
                                  onClick={(e) =>
                                    handleDeleteView(item.id, index)
                                  }
                                  className="cursor-pointer"
                                >
                                  <img
                                    src={deletes}
                                    className="lg:w-9 w-8"
                                    alt="Delete"
                                  />
                                </div>
                                <div
                                  className="ml-4 cursor-pointer"
                                  onClick={(e) => handleEdit(item)}
                                >
                                  <img
                                    src={edit}
                                    className="lg:w-9 w-8"
                                    alt="Delete"
                                  />
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="col-span-12 flex flex-wrap items-center sm:justify-end justify-center bg-white py-4 sm:px-8 px-0 rounded-lg">
                  <div className="flex items-center cursor-pointer">
                    <p
                      onClick={() => handlePageChange(pageNo - 1)}
                      disabled={pageNo === 1}
                    >
                      Previous
                    </p>
                    <div className="flex items-center mx-6">
                      {renderPaginationButtonss()}
                    </div>
                    <p
                      onClick={() => handlePageChange(pageNo + 1)}
                      disabled={pageNo === totalPage}
                    >
                      Next
                    </p>
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>

      <Dialog
        open={isAddUserRole}
        onClose={() => setIsAddUserRole(false)}
        size="md"
      >
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="p-4 sm:w-auto w-[330px] h-auto overflow-auto fontNew">
              <h4 className="text-lg font-semibold mb-2">
                {isUpdate ? "Update" : "Add"} User Role
              </h4>
              <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-12 ">
                  <div className="col-span-12 md:mx-2 mx-0 my-5">
                    <h4 className="text-sm font-medium mb-3">Role Name</h4>
                    <input
                      type="text"
                      value={roleName}
                      onChange={(e) => setRoleName(e.target.value)}
                      className="border-2 px-4 py-3 rounded-md w-full outline-[#e1c595]"
                      placeholder="Enter"
                    />
                  </div>
                </div>
                <div className="mt-6 flex justify-end">
                  <button
                    type="button"
                    onClick={() => setIsAddUserRole(false)}
                    className="bg-[#EF5F5F] py-2 px-7 text-white rounded-lg mr-5"
                  >
                    Close
                  </button>
                  {!isLoading ? (
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="bg-[#00987C] text-white h-[50px] w-30 rounded-lg"
                    >
                      {isUpdate ? "Update" : "Add"}
                    </button>
                  ) : (
                    <div className="flex justify-center items-center bg-[#00987C] text-white h-[50px] w-30 rounded-lg">
                      <Circles
                        width={25}
                        height={25}
                        color="#fff"
                        ariaLabel="circles-loading"
                        wrapperStyle={{}}
                        visible={true}
                        wrapperClass=""
                      />
                    </div>
                  )}
                </div>
              </form>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog open={isDelete} onClose={() => setIsDelete(false)} size="2xl">
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="flex justify-center text-center my-4 sm:px-16 px-4 fontNew">
              <div>
                <h4 className="text-xl font-semibold text-black mt-6">
                  Delete User Role?
                </h4>
                <p className="text-sm text-gray-500 my-3">
                  Are you sure you want to delete this User Role?
                </p>
                <div className="mt-13 flex items-center mb-5">
                  <button
                    className="bg-[#F4F5FA] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                    onClick={() => setIsDelete(false)}
                  >
                    Close
                  </button>
                  <button
                    disabled={isLoading}
                    className="bg-[#e29c29] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                    onClick={handleDelete}
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      "Yes, Delete"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>
    </div>
  );
}

export default UserRole;
